import { useState, useEffect } from 'react';

const useNetworkStatus = (): { isOnline: boolean } => {
    const [isOnline, setIsOnline] = useState<boolean>(() => {
        if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
            return navigator.onLine;
        }
        return true;
    });

    const updateNetworkStatus = () => {
        if (typeof navigator !== 'undefined') {
            setIsOnline(navigator.onLine);
        }
    };

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }
        updateNetworkStatus();
        window.addEventListener('online', updateNetworkStatus);
        window.addEventListener('offline', updateNetworkStatus);
        return () => {
            window.removeEventListener('online', updateNetworkStatus);
            window.removeEventListener('offline', updateNetworkStatus);
        };
    }, []);

    return { isOnline };
};

export default useNetworkStatus;

